import React, { useState, useRef, Fragment } from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import CustomTable from "../../common/CustomTable/CustomTable";
import { navigate } from "@reach/router";
import _ from "lodash";
import moment from "moment";
import queryString from "query-string";
import { useEffect } from "react";
import {
  getCaseLabelByStatus,
  getErrorMessage,
  numberFormat,
  parseTimeStamp,
} from "../../../helpers/functions";
import CaseManagerService from "../../../services/CaseManagerService";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import AlertDialog from "../../common/Alert";
import { PrimaryCTAButton } from "../../common/Buttons";
import CaseService from "../../../services/CaseService";
import usePrevious from "../../../hooks/usePrevious";

const initFilters = [
  { label: "All", key: "allCount", value: 0 },
  {
    label: "Waiting For Respondent",
    key: "awaitingRespondentOnBoardingCount",
    value: 0,
  },
  { label: "Under Resolution", key: "underResolution", value: 0 },
  { label: "Settled", key: "settled", value: 0 },
  { label: "Drafts", key: "draftCount", value: 0 },
];

const filterByStatus = (selectedFilter) => {
  let key = "status";
  let value = "";
  switch (selectedFilter) {
    case "Drafts":
      value = "draft";
      break;
    case "Under Resolution":
      value = "underResolution";
      break;
    case "Waiting For Respondent":
      value = "awaitingRespondent";
      break;
    case "Settled":
      value = "settled";
      break;
    default:
      break;
  }
  return { key, value };
};

async function getCases(query = "", id, caseType, role) {
  /*
  let param;
  if (caseType && id) {
    param = `?resolutionKind=${caseType}&${role}=${id}`;
  } else if (id) {
    param = `?${role}=${id}`;
  } else {
    param = `?resolutionKind=${caseType}`;
  }
  */
  try {
    const response = await CaseManagerService.getCaseListing(query);
    // const stats = await CaseManagerService.getCaseStats(param);
    const stats = {
      mediationCount: response?.mediationCount,
      negotiationCount: response?.negotiationCount,
      arbitrationCount: response?.arbitrationCount,
      draftCount: response?.draftCount,
      allCount: response?.allCount,
      activeCount: response?.activeCount,
      underResolution: response?.underResolution,
      settled: response?.settled,
      awaitingRespondentOnBoardingCount:
        response?.awaitingRespondentOnBoardingCount,
    };
    return { ...response, stats };
  } catch (error) {
    return error;
  }
}

let previousCaseType;

const Index = ({ id, caseType, currentCaseType, role = "" }) => {
  const [state, setState] = useState({});
  const [filters, setFilters] = useState(initFilters);
  const placeholderText = "Search Cases";
  const [selectedFilter, setSelectedFilter] = useState();
  const MTRef = useRef();
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(false);
  const [page, setPage] = useState(1);
  const filterPreviousValue = usePrevious(filters);

  function setStats(stats) {
    const mapped = initFilters.map((filter) => {
      let returnData = {
        label: filter.label,
        value: filter.value,
      };
      if (stats[filter.key] >= 0) {
        returnData.value = stats[filter.key];
      }
      return returnData;
    });
    setFilters(mapped);
  }

  useEffect(() => {
    if (selectedFilter || (caseType && filterPreviousValue)) {
      MTRef.current.onQueryChange({
        ...MTRef.current.state.query,
        page: 0,
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter, caseType]);

  const columns = [
    {
      field: "id",
      title: "Case ID",
      sorting: true,
      render: (rowData) => (
        <HyperLink
          onClick={() =>
            navigate(
              `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
            )
          }
        >
          {rowData.id}
        </HyperLink>
      ),
      tooltip: "Unique Identifier for the Case across IAMC platform",
      headerStyle: {
        maxWidth: 120,
        width: 120,
        padding: `12px 16px`,
      },
      cellStyle: {
        maxWidth: 120,
        width: 120,
        padding: `12px 16px`,
      },
    },
    {
      field: "title",
      title: "Case Title",
      render: (rowData) => (
        <Bold
          // style={{ inlineSize: 100, overflowWrap: "break-word" }}
          onClick={() =>
            navigate(
              `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
            )
          }
        >
          {rowData.title}
        </Bold>
      ),
      sorting: false,
    },
    {
      field: "party",
      title: "Party",
      tooltip: "Parties representing to file the case",
      render: (rowData) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(
              `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
            )
          }
        >
          {rowData?.claimantParty?.name}
        </div>
      ),
      //render: (rowData) => <>{rowData?.claimantParty?.name}</>,
      sorting: false,
    },
    {
      field: "respondentName",
      title: "Counterparty",
      sorting: false,
      tooltip: "Party countering your case",
      render: (rowData) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(
              `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
            )
          }
        >
          {rowData?.respondentParty?.name ? (
            rowData.respondentParty.name
          ) : rowData?.respondentName ? (
            rowData.respondentName
          ) : rowData?.respondentParties?.length ? (
            rowData?.respondentParties[0]?.name
          ) : (
            <div style={{ marginLeft: 35 }}>-</div>
          )}
        </div>
      ),
      // render: (rowData) => (
      //   <>
      //     {rowData?.respondentParty?.name ? (
      //       rowData.respondentParty.name
      //     ) : rowData?.respondentName ? (
      //       rowData.respondentName
      //     ) : (
      //       <div style={{ marginLeft: 35 }}>-</div>
      //     )}
      //   </>
      // ),
    },
    {
      field: "totalClaimValue",
      title: "Claim Value",
      tooltip: "Claim Value of the Case",
      render: (rowData) => {
        const divStyle = {
          cursor: "pointer",
        };
        const caseItems = rowData.totalClaimValue;
        if (caseItems)
          return (
            <div
              className="container"
              style={divStyle}
              onClick={() =>
                navigate(
                  `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
                )
              }
            >
              {numberFormat(
                parseFloat(caseItems).toFixed(2),
                rowData.currencyUnit,
              )}
            </div>
          );
        else
          return (
            <div
              className="container"
              style={divStyle}
              onClick={() =>
                navigate(
                  `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
                )
              }
            >
              {"Non Monetary"}
            </div>
          );
      },
      // render: (rowData) => {
      //   const caseItems = rowData.totalClaimValue;
      //   if (caseItems)
      //     return (
      //       "INR " +
      //       formatNumberToMetrics(parseFloat(caseItems).toFixed(2), "INR")
      //     );
      //   else return "Non Monetary";
      // },
      sorting: true,
      headerStyle: {
        maxWidth: 130,
        width: 130,
        padding: `12px 16px`,
      },
      cellStyle: {
        maxWidth: 130,
        width: 130,
        padding: `12px 16px`,
      },
    },
    /*
    {
      field: "nextHearingDate",
      title: labels["table.nextHearingDate"],
      render: (rowData) => (
        <div
          style={{
            marginLeft: "20px",
            cursor: "pointer",
          }}
          onClick={() =>
            navigate(
              `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`
            )
          }
        >
          {rowData?.nextHearingDate?.date
            ? rowData?.nextHearingDate?.date
            : "-"}
        </div>
      ),
      sorting: true,
      headerStyle: {
        maxWidth: 110,
        width: 110,
        padding: `12px 16px`,
      },
      cellStyle: {
        maxWidth: 110,
        width: 110,
        padding: `12px 16px`,
      },
    },
    */
    {
      field: "status",
      title: "Status",
      tooltip: "Status of the Case",
      render: (rowData) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(
              `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
            )
          }
        >
          {rowData?.respondentStatus === "declined" ? (
            <div className="pending-payment">Respondent Declined the Case</div>
          ) : (
            getCaseLabelByStatus(rowData)
          )}
        </div>
      ),
      headerStyle: {
        maxWidth: 110,
        width: 110,
        padding: `12px 16px`,
      },
      cellStyle: {
        maxWidth: 110,
        width: 110,
        padding: `12px 16px`,
      },
    },
    {
      field: "loanAccountNo",
      title: "Contract Number",
      hidden: caseType === "arbitration" ? false : true,
      render: (rowData) =>
        rowData.loanAccountNo ? (
          <div
            onClick={() =>
              navigate(
                `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
              )
            }
          >
            {rowData.loanAccountNo}
          </div>
        ) : (
          <div style={{ marginLeft: "25px", cursor: "pointer" }}>{"-"}</div>
        ),
      sorting: false,
      headerStyle: {
        padding: `12px 25px`,
      },
    },
    {
      field: "submittedOn",
      title: "Created On",
      tooltip: "Case Created Date",
      headerStyle: {
        width: 120,
      },
      render: (rowData) => (
        <Datecolumn>
          <div
            className="date"
            onClick={() =>
              navigate(
                `/dashboard/cases/${rowData.id}?caseType=${rowData?.resolutionKind}`,
              )
            }
          >
            {rowData?.submittedOn
              ? moment(rowData.submittedOn).format("DD/MM/YYYY")
              : moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}
          </div>
          {rowData?.status === "draft" && (
            <div
              className="delete"
              onClick={() => deleteWaring(false, rowData?.id)}
            >
              {"Delete"}
            </div>
          )}
        </Datecolumn>
      ),
    },
  ];

  const data = (query) =>
    new Promise((resolve, reject) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (previousCaseType !== currentCaseType) {
        params.page = 1;
        setPage(params.page);
      }
      previousCaseType = currentCaseType;
      if (query.search) {
        params.search = query.search;
      }
      params.selected = true;
      if (id) {
        params[role] = id;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      if (caseType) {
        params.resolutionKind = caseType;
      }
      const { key, value } = filterByStatus(selectedFilter);
      if (key && value) {
        params[key] = value;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getCases(stringParams, id, caseType, role)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result?.data?.map((row) => ({
                ...row,
                tableData: { checked: row?.isSelected },
              })),
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
            setStats(result.stats);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const handleCaseSelection = async (cases, data) => {
    const param = `?resolutionKind=${caseType}`;
    if (cases?.length >= 1 && !data) {
      try {
        setLoader({ state: true, message: "Modifying Cases..." });
        await CaseService.addAllCases(param);
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        MTRef.current.onQueryChange("");
      }
    } else if (cases?.length === 0 && !data) {
      try {
        setLoader({ state: true, message: "Modifying Cases..." });
        await CaseService.removeAllCases(param);
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        MTRef.current.onQueryChange("");
      }
    } else {
      try {
        setLoader({ state: true, message: "Modifying Cases..." });
        if (data?.isSelected) {
          await CaseService.removeCaseItem(data.id);
        } else {
          await CaseService.selectCaseItem(data?.id);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        MTRef.current.onQueryChange("");
      }
    }
  };

  const deleteWaring = (isSelectAll, id) => {
    setOpen(true);
    setDialogData({
      primaryBtnText: "Proceed",
      secondaryBtnText: "Cancel",
      clickPrimaryBtn: () =>
        isSelectAll ? deleteSelectedDraft() : deleteDraft(id),
      clickSecondarybtn: () => setOpen(false),
      onDialogClose: () => setOpen(false),
      desc: `Are you sure you want to delete this draft case(s)?`,
      heading: "Delete Case",
      descriptionTextStyle: {
        margin: "0px 60px 50px",
        textAlign: "center",
        fontFamily: theme.fonts.primaryFontSemiBold,
      },
    });
  };

  /**
   * @description Function to deleted the selected case
   */
  const deleteSelectedDraft = async () => {
    try {
      setLoader({ state: true, message: "Deleting Cases..." });
      const res = await CaseService.deleteSelectedCases();
      if (res?.message) {
        enqueueSnackbar(res?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      MTRef.current.onQueryChange("");
      setOpen(false);
    }
  };

  /**
   * @description Function to trigger the delete case
   * @param {*} param0
   */
  const deleteDraft = async (id) => {
    try {
      setLoader({ state: true, message: "Deleting Cases..." });
      const res = await CaseService.deleteDraftCase(id);
      if (res?.message) {
        enqueueSnackbar(res?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      MTRef.current.onQueryChange("");
      setOpen(false);
    }
  };

  return (
    <Fragment>
      <Padding>
        <CustomTable
          hidePagination={state.lastPage === 1}
          pageSize={state?.data?.length ? state?.data?.length : 10}
          pluralTitle="Cases"
          selection={selectedFilter === "Drafts" && !role}
          onSelectionChange={handleCaseSelection}
          singularTitle=""
          {...{
            columns,
            data,
            filters,
            selectedFilter,
            setSelectedFilter,
            placeholderText,
            MTRef,
            page,
            setPage,
          }}
          state={state}
        />
        <Footer>
          <div className="flex mt20">
            <div
              style={{
                display:
                  selectedFilter === "Drafts" &&
                  state?.data?.some((el) => el.isSelected)
                    ? "flex"
                    : "none",
                flex: 1,
                justifyContent: "flex-end",
              }}
            >
              <DangerBtn
                style={{
                  width: "216px",
                  marginLeft: "26px",
                }}
                onClick={() => deleteWaring(true)}
              >
                {"Delete"}
              </DangerBtn>
            </div>
          </div>
        </Footer>
        <AlertDialog isOpen={open} {...{ ...dialogData }} />
      </Padding>
    </Fragment>
  );
};

export default Index;

const Padding = styled.div`
  padding: 32px 48px;
  background: #fafafa;
  min-height: 100vh;
`;

const HyperLink = styled.span`
  cursor: pointer;
  color: ${COLORS.BTN_GREEN};
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;
`;

const Bold = styled.span`
  cursor: pointer;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  line-height: 20px;
  color: #293461;
  display: block;
  max-width: 220px;
  overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
`;

const Datecolumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  .date {
    cursor: pointer;
    font-size: 14px;
    color: #333;

    &:hover {
      opacity: 0.7;
    }
  }
  .delete {
    cursor: pointer;
    color: ${COLORS.LOGOUT_RED};
    font-size: 12px;
    font-weight: 600;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Footer = styled.footer`
  margin-top: 24px;

  & .highlighted {
    color: red;
    margin-top: 10px;
    font-size: 12px;
    font-family: ${theme.fonts.primaryFontSemiBold};
  }
`;

export const DangerBtn = styled(PrimaryCTAButton)`
  background-color: #d91b1b;
  border: 1px solid #d91b1b;
  border-radius: 8px !important;
  padding: 10px 18px !important;
  font-weight: 600 !important;
  font-size: 14px !important;

  &:hover {
    background-color: #d91b1b;
    border-color: #d91b1b;
  }

  &:active {
    background-color: #d91b1b;
    border-color: #d91b1b;
  }
`;
